import EventGameFixtureEnumModel from "./EventGameFixtureEnumModel";
import EventGameFixtureNumberModel from "./EventGameFixtureNumberModel";

export enum EventGameOutcomeTypeEnum {
  BOOLEAN = "BOOLEAN",
  NUMBER = "NUMBER",
  ENUM = "ENUM",
  FREE_INPUT = "FREE_INPUT",
}

export enum EventGameFixtureStatusEnum {
  ACTIVE = "ACTIVE",
  SETTLED = "SETTLED",
  VOID = "VOID",
}

type ValidOutcomesType<T extends EventGameOutcomeTypeEnum> =
  T extends EventGameOutcomeTypeEnum.BOOLEAN
    ? null
    : T extends EventGameOutcomeTypeEnum.NUMBER
    ? EventGameFixtureNumberModel
    : T extends EventGameOutcomeTypeEnum.ENUM
    ? EventGameFixtureEnumModel
    : T extends EventGameOutcomeTypeEnum.FREE_INPUT
    ? null
    : never;

type OutcomeType<T extends EventGameOutcomeTypeEnum> =
  T extends EventGameOutcomeTypeEnum.BOOLEAN
    ? boolean | null
    : T extends EventGameOutcomeTypeEnum.NUMBER
    ? number | null
    : T extends EventGameOutcomeTypeEnum.ENUM
    ? string | null
    : T extends EventGameOutcomeTypeEnum.FREE_INPUT
    ? string | null
    : never;

export default class EventGameFixturesModel<
  T extends EventGameOutcomeTypeEnum = EventGameOutcomeTypeEnum
> {
  public id: string = "";
  public question: string = "";
  public status: EventGameFixtureStatusEnum = EventGameFixtureStatusEnum.ACTIVE;
  public voidReason: string | null = null;
  public points: number = 0;
  public outcomeType: T = null as unknown as T;
  public validOutcomes: ValidOutcomesType<T> =
    null as unknown as ValidOutcomesType<T>;
  public outcome: OutcomeType<T> = null as unknown as OutcomeType<T>;
}
